import React, { useEffect, useState, useContext } from 'react';
import { useNavigateParams } from '../../../hooks/useNavigateParams';

import { Context } from '../../../context/UserContext';
import Form from './Form';
import ConveniosPanel from './ConveniosPanel';
import styles from '../../form/Form.module.css';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';

import * as DataListAPI from '../../../api/dataList';
import * as EmpresaAPI from '../../../api/empresa';
import CrudsAPI from '../../../api/CRUDs';

//helpers
import { getEmpresaScope } from '../../../helpers/sessionEmpresa';
import { resolveEmpresaTabela } from '../../../utils/funcoes';

const CreateOrEdit = () => {
    const { empresaId, empresaIds } = getEmpresaScope();

    const [dados, setDados] = useState({
        empresaId: empresaId,
        ativo: true,
    });
    const [contaPersistida, setContaPersistida] = useState(null);
    const [banco, setBanco] = useState({});
    const [itens, setItens] = useState([]); //itens da grid chave pix

    const [token] = useState(localStorage.getItem('token')) || '';
    const { parametro } = useContext(Context);
    const empresaTabelaId = resolveEmpresaTabela(parametro, empresaId);
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();
    const urlParams = new URLSearchParams(window.location.search);

    const pathname = '/Contas';
    const ul = urlParams.get('ul');
    const li = urlParams.get('li');
    const tipo = urlParams.get('tipo');
    const operacaoUUID = urlParams.get('operacao');
    const uuid = urlParams.get('uuid');
    const btnText = urlParams.get('btnText');

    const params = new URLSearchParams({
        ul: ul,
        li: li,
        tipo: tipo,
        operacao: operacaoUUID,
        uuid: uuid,
        btnText: btnText,
    });

    //enums e tabelas
    const [OptionsEmpresa, setEmpresa] = useState([]);
    const [OptionsBanco, setOptionsBanco] = useState([]);

    //carregar API's Externas
    const consultaEmpresa = async () => {
        const result = await EmpresaAPI.empresa(empresaId);
        setEmpresa(result);
    };
    //DataList
    const consultaBanco = async (obj) => {
        const result = await DataListAPI.dataList(obj);
        setOptionsBanco(result);
    };

    useEffect(() => {
        if (!token) {
            navigate('/Auth', { replace: true });
        }
    }, [token, navigate]);

    useEffect(() => {
        consultaEmpresa();
        consultaBanco({ empresaId: empresaTabelaId, tabela: 'Banco', id: 'id', descricao: 'descricao' });

        setContaPersistida(null);
        if (uuid && uuid !== 'null') {
            //consulta a API
            CrudsAPI.conta
                .consulta(uuid)
                .then((response) => {
                    setDados(response.data);
                    setContaPersistida(response.data);
                    setBanco(response.data?.Banco || {});
                    setItens(response.data?.chavePIXes || []);
                })
                .catch((error) => {
                    console.error(error);
                    setFlashMessage(error.response.data.message, error.response.data.type);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uuid]);

    async function managerDados(dados) {
        let urlNavigate = pathname;
        try {
            let response;

            if (uuid && uuid !== 'null') {
                response = await CrudsAPI.conta.editar(dados);
            } else {
                response = await CrudsAPI.conta.cadastrar(dados);

                if (response.status === 202) {
                    setDados(response.data);
                    response.data.message = 'Registro em duplicidade!';
                    response.data.type = 'warning';
                    urlNavigate = pathname + '/CreateOrEdit';
                    params.set('uuid', response.data.uuid);
                    params.set('btnText', 'Atualizar');
                }
            }

            setFlashMessage(response.data.message, response.data.type);

            setTimeout(() => {
                navigate(urlNavigate, params);
            }, parametro.msgTempo * 1000);
        } catch (error) {
            console.error(error);
            setFlashMessage(error.response.data.message, error.response.data.type);
        }
    }
    return (
        <section className={`${styles.form_container} ${styles[parametro.tema]}`}>
            <Form
                token={token}
                dados={dados}
                setDados={setDados}
                empresaId={empresaId}
                empresaIds={empresaIds}
                handleSubmit={managerDados}
                btnText={btnText}
                OptionsEmpresa={OptionsEmpresa}
                OptionsBanco={OptionsBanco}
                setOptionsBanco={setOptionsBanco}
                banco={banco}
                setBanco={setBanco}
                itens={itens}
                setItens={setItens}
                caminhoVoltar={pathname}
                empresaTabelaId={empresaTabelaId}
                consultaBanco={consultaBanco}
            />
            <ConveniosPanel
                key={uuid || 'nova-conta'}
                conta={contaPersistida}
                bloqueado={
                    Boolean(contaPersistida) &&
                    ['empresaId', 'bancoId', 'agencia', 'conta', 'operacao', 'ativo'].some(
                        (key) => String(dados[key] ?? '').trim() !== String(contaPersistida[key] ?? '').trim()
                    )
                }
            />
        </section>
    );
};
export default CreateOrEdit;
